import React from 'react';
import { Search, PlusCircle } from 'lucide-react';

export default function PropertiesTab({
  PROPRIEDADES,
  selectedPropriedade,
  setSelectedPropriedade,
  searchTerm,
  setSearchTerm,
  sidebarStatusFilter,
  setSidebarStatusFilter,
  setNewStay,
  setActiveTab,
  selectedPropertyStays,
  focarInquilinoNaTimeline,
  formatDateToPt,
  obterStatusRealStay,
  startEdit,
  deleteStay
}) {
  return (
    <div className="space-y-6 animate-fadeIn">
      {/* Seleção de Apartamento */}
      <div className="bg-white p-5 rounded-2xl shadow-sm border border-slate-200">
        <label className="block text-xs font-bold uppercase tracking-wider text-slate-400 mb-3">
          Seleciona o Apartamento para Gerir Contratos e Residentes:
        </label>
        <div className="flex flex-wrap gap-2">
          {PROPRIEDADES.map((prop) => (
            <button
              key={prop}
              onClick={() => {
                setSelectedPropriedade(prop);
                setSearchTerm("");
              }}
              className={`px-3.5 py-2.5 rounded-xl text-xs font-bold transition-all ${
                selectedPropriedade === prop
                  ? "bg-slate-900 text-white shadow-md"
                  : "bg-slate-100 text-slate-600 hover:bg-slate-200"
              }`}
            >
              {prop}
            </button>
          ))}
        </div>
      </div>

      {/* Filtros e Ações */}
      <div className="bg-white p-4 rounded-2xl shadow-sm border border-slate-200 flex flex-col md:flex-row justify-between items-center gap-4">
        <div className="relative w-full md:w-96">
          <Search className="absolute left-3.5 top-3 h-4 w-4 text-slate-400" />
          <input
            type="text"
            placeholder="Pesquisar inquilino ou quarto..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="pl-10 pr-4 py-2 w-full bg-slate-50 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-slate-500 focus:bg-white transition-all text-slate-800"
          />
        </div>
        <div className="flex items-center gap-3 w-full md:w-auto justify-end">
          <select
            value={sidebarStatusFilter}
            onChange={(e) => setSidebarStatusFilter(e.target.value)}
            className="bg-amber-50 border border-amber-200 text-xs font-black px-3 py-2 rounded-xl focus:outline-none text-amber-800"
          >
            <option value="Todos">Todos os Estados</option>
            <option value="Em Processo">⏳ Em Processo</option>
            <option value="Devolvida">✅ Devolvida</option>
          </select>
          <button
            onClick={() => {
              setNewStay((prev) => ({
                ...prev,
                propriedade: selectedPropriedade,
              }));
              setActiveTab("addStay");
            }}
            className="bg-slate-950 hover:bg-slate-900 text-white text-xs font-bold px-4 py-2.5 rounded-xl flex items-center gap-2 transition-all"
          >
            <PlusCircle className="h-4 w-4" /> Novo Inquilino
          </button>
        </div>
      </div>

      {/* Tabela de Inquilinos */}
      <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="bg-slate-50 text-slate-600 uppercase text-xs font-bold border-b border-slate-200">
                <th className="px-6 py-4">Quarto</th>
                <th className="px-6 py-4">Inquilino</th>
                <th className="px-6 py-4 text-right">Renda Base</th>
                <th className="px-6 py-4 text-right">Caução / Admin</th>
                <th className="px-6 py-4">Check-In</th>
                <th className="px-6 py-4">Check-Out</th>
                <th className="px-6 py-4 text-center">Estado</th>
                <th className="px-6 py-4">Notes</th>
                <th className="px-6 py-4 text-center">Ações</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100 text-xs">
              {selectedPropertyStays.map((stay) => (
                <tr key={stay.id} className="hover:bg-slate-50/50 transition-colors">
                  <td className="px-6 py-4 font-bold text-slate-900">{stay.quarto}</td>
                  <td className="px-6 py-4">
                    <button
                      onClick={() => focarInquilinoNaTimeline(stay.id)}
                      className="text-slate-955 hover:text-slate-700 hover:underline font-extrabold text-left"
                    >
                      {stay.inquilino}
                    </button>
                  </td>
                  <td className="px-6 py-4 text-right font-black text-slate-900">
                    {stay.estadiasAnteriores && (
                      <p className="text-[10px] text-amber-600 bg-amber-50 px-1.5 py-0.5 rounded mt-1 border border-amber-100 italic w-fit">
                        xml ⏮ Anterior: {stay.estadiasAnteriores}
                      </p>
                    )}
                    {stay.renda}€
                  </td>
                  <td className="px-6 py-4 text-right font-semibold">{stay.caucao}€</td>
                  <td className="px-6 py-4">{formatDateToPt(stay.checkIn)}</td>
                  <td className="px-6 py-4">{formatDateToPt(stay.checkOut)}</td>
                  <td className="px-6 py-4 text-center">
                    <span
                      className={`px-2.5 py-1 rounded-full font-bold ${
                        obterStatusRealStay(stay) === "Concluído"
                          ? "bg-slate-100 text-slate-600"
                          : "bg-emerald-100 text-emerald-800"
                      }`}
                    >
                      {obterStatusRealStay(stay)}
                    </span>
                  </td>
                  <td className="px-6 py-4 truncate max-w-xs">{stay.notes || stay.notas}</td>
                  <td className="px-6 py-4 text-center">
                    <div className="flex justify-center gap-1.5">
                      <button
                        onClick={() => focarInquilinoNaTimeline(stay.id)}
                        className="bg-white hover:bg-slate-100 text-slate-800 border border-slate-200 px-2.5 py-1.5 rounded-xl font-bold shadow-sm"
                      >
                        Tranches
                      </button>
                      <button
                        onClick={() => startEdit(stay)}
                        className="bg-white hover:bg-slate-100 text-slate-600 border border-slate-200 px-2.5 py-1.5 rounded-xl font-bold shadow-sm"
                      >
                        Editar
                      </button>
                      <button
                        onClick={() => deleteStay(stay.id)}
                        className="bg-rose-50 hover:bg-rose-100 text-rose-600 border border-rose-200 px-2.5 py-1.5 rounded-xl font-bold shadow-sm"
                      >
                        Apagar
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
